import React, { useEffect, useState, useRef, useMemo } from "react";
import { Button } from 'antd';
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ArrowRightOutlined } from '@ant-design/icons';
import { generateClassName } from "jzfz-web-utils";
import { queryMenuContentList } from '../../store/action';
import { ObjTest } from "../../util/common";
import { constantConfig, commonUtil } from 'web-common';
import { VideoModal } from './component/VideoModal';
import { ViewportImg } from '../../component/viewportImg';
import './style/aesthetice.less';



const banner = require('../../assets/images/aestheticeBanner.jpg');
const playBtn = require('../../assets/images/play_btn.png');


const { ModuleTypeEnum, WEBSITE_PATHS } = constantConfig;
const { waterColumnsArray } = commonUtil;


// 列表子项边距
const MARGIN = 32;


/**
 * 视觉美学
 */
const Aesthetice = () => {

	const history = useHistory();

	const { isMobile } = useSelector((state: any) => state.reducer);

	const [contentList, setContentList] = useState<any[]>([]);
	// video visible, 视频弹窗显隐
	const [visible, setVisible] = useState<boolean>(false);
	// vieo item, 视频信息，包括简介内容等
	const [currentItem, setCurrentItem] = useState<any>(null);
	const containerRef = useRef<any>(null);
	// 设置渲染的列数
	const columnCount = useMemo(() => isMobile ? 1 : 4, [isMobile]);


	useEffect(() => {
		initContentList();
	}, []);


	/**
	 * 初始化内容列表
	 */
	const initContentList = async () => {
		const result = await queryMenuContentList(ModuleTypeEnum.AESTHETICS);
		const arrs = result.data || [];
		if (Array.isArray(arrs)) {
			setContentList(arrs);
		}
	};


	/**
	 * 计算列的宽度
	 * @param item
	 */
	const getColumnWidth = () => {
		if (isMobile) {
			return '100%';
		}
		if (containerRef.current && columnCount) {
			const width = containerRef.current.offsetWidth;
			const marginCount = MARGIN * (columnCount - 1);
			return (width - marginCount) / columnCount;
		}
		return 0;
	};


	/**
	 * 跳转到基准之道页面
	 */
	const openAestheticePath = () => {
		history.replace(WEBSITE_PATHS.periodical);
	};


	/**
	 * 打开或关闭视频弹窗
	 * @param item 
	 */
	const handleVideoVisible = (item?: any) => {
		const tempVisbile = item ? true : false;
		setVisible(tempVisbile);
		setCurrentItem(item || null);
	};


    return (
		<div className="company-aesthetice-wrapper">
			{/* banner */}
			<div className="banner ofh">
				<img src={banner} loading="lazy" className={generateClassName([isMobile ? "imagec" : 'w'])} />
				<div className="structure">大咨询 ｜ 大设计 ｜ 大管理</div>
			</div>

			{/* 线 */}
			<div className={generateClassName(["tr ptb24 link-title", isMobile ? "mlr16" : "mlr75"])}>
				<span className="f12 crp" onClick={openAestheticePath}>基准之道<ArrowRightOutlined /></span>
			</div>

			{/* 内容-视觉美学 */}
			<div className={isMobile ? "mlr16" : "mlr75"}>
				<div className={generateClassName(["mt18 content-title", isMobile ? "f18" : "f36"])}>
					视频美学
				</div>
				<div className="mb60 w pt12 flex read-list" ref={containerRef}>
					{
						(waterColumnsArray(contentList, columnCount) || []).map((columns: any[], columnsIndex: number) => {
							return (
								<div key={columnsIndex} style={{ width: getColumnWidth(), marginLeft: columnsIndex > 0? MARGIN : 0 }}>
									{
										ObjTest.isNotEmptyArray(columns) ? (
											(columns || []).map((v, vi) => {
												if (!v) { return null;}
												return (
													<div key={vi} className="read-item mt24">
														<div className="poster-image" onClick={() => handleVideoVisible(v)}>
															<ViewportImg src={v.coverImage} className="w" />
															<img src={playBtn} className="poster-play-btn" loading="lazy" />
														</div>
														<div className="flexjs p5">
															<div className={generateClassName(["name eps2", isMobile ? "f14" : "f18"])}>{v.title}</div>
															<div className="other flexie flexjs lh28 f12">
																<div title="占位" />
																<div className="date">{moment(v.updateTime || new Date()).format('YYYY-MM-DD')}</div>
															</div>
														</div>
													</div>
												);
											})
										) : (
											null
										)
									}
								</div>
							);
						})
					}
				</div>
			</div>

			{/* 视觉美学视频播放弹窗			 */}
			<VideoModal 
				visible={visible}
				item={currentItem}
				onFinish={() => {
					handleVideoVisible();
				}}
			/>
		</div>
	)
};

export { Aesthetice };